import React, { useState, useEffect, Fragment } from 'react';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import axios from 'axios';
import ProgressComponent from '../components/progress';
import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';

const totalSteps = 3;

const INITIAL_HEADERS = [
    { key: 'company_id', value: '' },
    { key: 'description', value: '' },
    { key: 'start_date', value: '' },
    { key: 'end_date', value: '' },
    { key: 'quantity', value: '' },
    { key: 'price', value: '' },
]

const INITIAL_FORM_DATA = {
    supplier: '',
    file: '',
}

const INITIAL_IMPORT_DATA = [];

const INITIAL_ROWS = [];


const SubscriptionsComponent = () => {

    const [step, setStep] = useState(1);
    const [finished, setFinished] = useState(false);
    const [fileExtension, setFileExtension] = useState(null);
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [file, setFile] = useState(null);

    const [headers, setHeaders] = useState([]);
    const [rows, setRows] = useState(INITIAL_ROWS);
    const [importData, setImportData] = useState(INITIAL_IMPORT_DATA);

    const [totalItems, setTotalItems] = useState(0);
    const [importedItems, setImportedItems] = useState(0);

    const [selectedHeaders, setSelectedHeaders] = useState(INITIAL_HEADERS);

    useEffect(() => {
        if (file) {
            const extension = file.name.split('.').pop();
            setFileExtension(extension);
        }
    }, [file]);

    const handleExcelParse = (file) => {
        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = evt.target.result;
            const workbook = XLSX.read(data, { type: 'binary' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            const headers = sheetData[0];
            const rows = sheetData.slice(1);

            setHeaders(headers);
            setRows(rows);
        }

        reader.readAsBinaryString(file);

    }

    const handleCsvParse = (file) => {
        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = evt.target.result;
            const result = Papa.parse(data, { header: true });

            setHeaders(Object.keys(result.data[0]));
            setRows(result.data);
        }

        reader.readAsText(file);
    }

    const buttonDisabled = () => {
        if (step === 1) {
            if (formData.supplier && formData.file && headers.length && rows.length) {
                return false;
            }
        }

        if (step === 2) {
            if (selectedHeaders.every(header => header.value)) {
                return false;
            }
        }

        if (step === 3) {
            if (importData.length) {
                return false;
            }
        }

        return true;
    }

    const handleImport = async () => {

        setTotalItems(importData.length);

        console.log('importeren gestart...');

        await Promise.all(importData.map(async (data) => {
            const postData = {
                vendor: formData.supplier,
                ...data,
            };

            console.log('importeren', postData);

            const headers = {
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'Authorization': 'Bearer ' + document.querySelector('meta[name="api-token"]').getAttribute('content')
            }

            await axios.post('/api/v1/subscriptions', postData, { headers })
                .then(response => {
                    setImportedItems(importedItems + 1);
                }).finally(() => {
                    if (importedItems === totalItems) {
                        setFinished(true);
                    }
                });
        }));
    }

    useEffect(() => {
        if (finished) {
            setStep(1);
            setFile(null);
            setFileExtension(null);
            setFormData(INITIAL_FORM_DATA);
            setHeaders([]);
            setRows(INITIAL_ROWS);
            setImportData(INITIAL_IMPORT_DATA);
        }
    }, [finished]);


    useEffect(() => {
        if (fileExtension !== null) {

            if (fileExtension === 'xls' || fileExtension === 'xlsx') {
                handleExcelParse(file);
            }

            if (fileExtension === 'csv') {
                handleCsvParse(file);
            }

        }
    }, [fileExtension]);

    return (
        <Fragment>
            <h5 className="text-center card-title">
                Abonnementen importeren
            </h5>
            <ProgressComponent step={step} totalSteps={totalSteps} setStep={setStep} />

            <div className="mt-5">
                {step === 1 && (
                    <Step1 formData={formData} setFormData={setFormData} setFile={setFile} />
                )}

                {step === 2 && (
                    <Step2
                        formData={formData}
                        setFormData={setFormData}
                        headers={headers}
                        rows={rows}
                        selectedHeaders={selectedHeaders}
                        setSelectedHeaders={setSelectedHeaders}
                    />
                )}

                {step === 3 && (
                    <Step3
                        headers={headers}
                        rows={rows}
                        selectedHeaders={selectedHeaders}
                        importData={importData}
                        setImportData={setImportData}
                        progress={(importedItems / totalItems) * 100}
                    />
                )}

            </div>

            <div className="mt-5 text-end">
                {step !== totalSteps && (
                    <Button
                        variant="primary"
                        onClick={() => setStep(step + 1)}
                        className={buttonDisabled() ? 'disabled' : ''}
                    >
                        Volgende
                    </Button>
                )}

                {step === totalSteps && (
                    <Button
                        variant="success"
                        className={buttonDisabled() ? 'disabled text-white' : 'text-white'}
                        onClick={() => handleImport()}
                    >
                        Importeren
                    </Button>
                )}

            </div>

        </Fragment>
    );
};

export default SubscriptionsComponent;
